import { FormGroup, InternationalAddress as KiamaInternationalAddress } from '@snsw/react-component-library';
import { OverseasAddressModel } from './types';
import { ReactNode } from 'react';

type Props = {
  /** Unique ID used to prefix the form fields */
  id: string;

  /** Label to show above the input component */
  label: ReactNode;

  helpMessage?: ReactNode;

  value?: OverseasAddressModel;
  onChange: (value: OverseasAddressModel) => void;
};

const DEFAULT_VALUE: OverseasAddressModel = {
  country: { value: '' },
  address1: { value: '' },
};

export const OverseasAddress = ({ id, label, helpMessage, value, onChange }: Props) => {
  return (
    <FormGroup id={`${id}-form-group`} label={label} helpMessage={helpMessage}>
      <KiamaInternationalAddress id={id} label={label} value={value ?? DEFAULT_VALUE} onChange={onChange} />
    </FormGroup>
  );
};
